define(['backbone'], (Backbone) => Backbone.Model.extend({
    initialize (attributes, options) {
        options = options || {};

        this._id = options.id;
        this.fetch();
        this.listenTo(this, 'change', function (obj) {
            this.save(obj.attributes);
        });
    },

    fetch () {
        this.set(JSON.parse(localStorage.getItem(this._id)));
    },

    save (attributes) {
        this.set(attributes);
        localStorage.setItem(this._id, JSON.stringify(this.toJSON()));
    },

    destroy () {
        localStorage.removeItem(this._id);
    },

    isEmpty () {
        return localStorage.length === 0;
    }
}));
